(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hd-collection"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('hd-collection'))customElements.define('hd-collection',class extends HTMLElement{connectedCallback(){if(this.dataset.ready)return;this.dataset.ready='true';const panel=this.querySelector('.hc-filter-panel');const mobile=window.matchMedia('(max-width:699px)');const setPanel=()=>{if(panel)panel.open=!mobile.matches};setPanel();this._mobile=mobile;this._setPanel=setPanel;mobile.addEventListener('change',setPanel);const form=this.querySelector('.hc-filter-form');this.querySelector('[data-hc-sort]')?.addEventListener('change',()=>form?.requestSubmit());form?.addEventListener('submit',event=>{const min=form.querySelector('input[name="filter.v.price.gte"]');const max=form.querySelector('input[name="filter.v.price.lte"]');if(min?.value&&max?.value&&Number(min.value)>Number(max.value)){const value=min.value;min.value=max.value;max.value=value}form.querySelectorAll('input[type="number"]').forEach(input=>{if(input.value==='')input.disabled=true});});}disconnectedCallback(){this._mobile?.removeEventListener('change',this._setPanel);}});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hd-ed-header"]) return;
  try {
    
document.addEventListener('click', function(event) {
  document.querySelectorAll('.hd-header details[open]').forEach(function(details) {
    if (!details.contains(event.target) || event.target.closest('a')) details.open = false;
  });
});
document.addEventListener('keydown', function(event) {
  if (event.key !== 'Escape') return;
  document.querySelectorAll('.hd-header details[open]').forEach(function(details) {
    details.open = false;
    details.querySelector('summary').focus();
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hd-eu-warranty"]) return;
  try {
    
  if (!customElements.get('hd-eu-warranty')) {
    customElements.define('hd-eu-warranty', class extends HTMLElement {
      connectedCallback() {
        if (this.warrantyBound) return;
        this.warrantyBound = true;
        const service = document.querySelector('.studio-service');
        if (service) service.before(this);
        const trigger = this.querySelector('.hd-eu-warranty__trigger');
        const dialog = this.querySelector('dialog');
        trigger.addEventListener('click', event => {
          if (typeof dialog.showModal !== 'function') return;
          event.preventDefault();
          dialog.showModal();
        });
        this.querySelector('[data-warranty-close]').addEventListener('click', () => dialog.close());
        dialog.addEventListener('close', () => trigger.focus({preventScroll:true}));
        dialog.addEventListener('click', event => {
          if (event.target !== dialog) return;
          const rect = dialog.getBoundingClientRect();
          if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
        });
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hd-food-product"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('hd-food-product')){
  customElements.define('hd-food-product',class extends HTMLElement{
    connectedCallback(){
      this.events=new AbortController();
      this.addEventListener('click',event=>{
        const foodLink=event.target.closest('[data-food-information]');
        if(foodLink){const panel=this.querySelector(foodLink.getAttribute('href'));if(panel)panel.open=true;}
        const thumbnail=event.target.closest('[data-photo]');
        if(!thumbnail)return;
        const hero=this.querySelector('.studio-primary');
        if(!hero)return;
        const photo=hero.querySelector('img');
        photo.removeAttribute('srcset');photo.src=thumbnail.dataset.photo;photo.alt=thumbnail.dataset.alt;hero.href=thumbnail.dataset.large;
        this.querySelectorAll('[data-photo]').forEach(button=>button.setAttribute('aria-pressed',String(button===thumbnail)));
        this.querySelector('.studio-pictures').scrollTo({left:0,behavior:'instant'});
      },{signal:this.events.signal});
      this.addEventListener('change',event=>{if(event.target.matches('[data-studio-option]'))this.choose(event.target);},{signal:this.events.signal});
      this.addEventListener('submit',event=>{if(event.target.matches('.studio-form')){event.preventDefault();this.add(event.target);}},{signal:this.events.signal});
    }
    disconnectedCallback(){this.events?.abort();this.variantRequest?.abort();}
    showError(message){const error=this.querySelector('.studio-error');error.textContent=message||error.dataset.fallback;error.hidden=false;}
    async choose(control){
      this.variantRequest?.abort();this.variantRequest=new AbortController();
      const position=control.dataset.studioOption;
      const target=new URL(control.selectedOptions[0].dataset.url||this.dataset.productUrl,location.origin);
      const browserURL=new URL(location.href);
      for(const key of ['view','preview_theme_id'])if(browserURL.searchParams.has(key))target.searchParams.set(key,browserURL.searchParams.get(key));
      const optionIds=[...this.querySelectorAll('[data-studio-option]')].map(input=>input.value);
      target.searchParams.set('option_values',optionIds.join(','));target.searchParams.set('section_id',this.dataset.section);
      this.querySelectorAll('.studio-add').forEach(button=>button.disabled=true);this.setAttribute('aria-busy','true');this.querySelector('.studio-error').hidden=true;
      try{
        const response=await fetch(target,{signal:this.variantRequest.signal});if(!response.ok)throw new Error();
        const documentFragment=new DOMParser().parseFromString(await response.text(),'text/html');
        const fresh=documentFragment.querySelector('hd-food-product');if(!fresh)throw new Error();
        const oldQuantity=Number(this.querySelector('[name=quantity]').value);const quantity=fresh.querySelector('[name=quantity]');
        const minimum=Number(quantity.min)||1;const increment=Number(quantity.step)||1;const maximum=Number(quantity.max)||Infinity;
        quantity.value=Math.min(maximum,minimum+Math.max(0,Math.floor((oldQuantity-minimum)/increment))*increment);
        const property=this.querySelector('[name="properties[Wunschtext]"]');const nextProperty=fresh.querySelector('[name="properties[Wunschtext]"]');if(property&&nextProperty)nextProperty.value=property.value;
        this.replaceWith(fresh);fresh.querySelector('[data-studio-option="'+position+'"]')?.focus({preventScroll:true});
        browserURL.pathname=target.pathname;browserURL.searchParams.delete('option_values');
        if(fresh.dataset.variant)browserURL.searchParams.set('variant',fresh.dataset.variant);else{browserURL.searchParams.delete('variant');browserURL.searchParams.set('option_values',optionIds.join(','));}
        history.replaceState({},'',browserURL);
      }catch(error){if(error.name!=='AbortError'){this.removeAttribute('aria-busy');this.showError();}}
    }
    async add(form){
      if(this.submitting)return;this.submitting=true;
      const buttons=[...this.querySelectorAll('.studio-add')];buttons.forEach(button=>button.disabled=true);
      this.querySelector('.studio-error').hidden=true;this.querySelector('.studio-success').hidden=true;
      this.querySelectorAll('[data-studio-option]').forEach(input=>input.disabled=true);
      try{
        const response=await fetch(this.dataset.add+'.js',{method:'POST',headers:{Accept:'application/json'},body:new FormData(form)});
        const result=await response.json();if(!response.ok)throw new Error(typeof result.description==='string'?result.description:'');
        this.querySelector('.studio-success').hidden=false;
        const cartResponse=await fetch(this.dataset.cart+'.js',{headers:{Accept:'application/json'}});
        if(cartResponse.ok){const cart=await cartResponse.json();document.querySelectorAll('[data-studio-cart-count]').forEach(count=>count.textContent=cart.item_count);}
      }catch(error){this.showError(error.message);}finally{this.submitting=false;buttons.forEach(button=>button.disabled=false);this.querySelectorAll('[data-studio-option]').forEach(input=>input.disabled=false);}
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hd-general-product"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('hd-general-product')){
  customElements.define('hd-general-product',class extends HTMLElement{
    connectedCallback(){
      this.events=new AbortController();
      this.addEventListener('click',event=>{
        const thumbnail=event.target.closest('[data-photo]');
        if(!thumbnail)return;
        const hero=this.querySelector('.studio-primary');
        if(!hero)return;
        const photo=hero.querySelector('img');
        photo.removeAttribute('srcset');photo.src=thumbnail.dataset.photo;photo.alt=thumbnail.dataset.alt;hero.href=thumbnail.dataset.large;
        this.querySelectorAll('[data-photo]').forEach(button=>button.setAttribute('aria-pressed',String(button===thumbnail)));
        this.querySelector('.studio-pictures').scrollTo({left:0,behavior:'instant'});
      },{signal:this.events.signal});
      this.addEventListener('change',event=>{if(event.target.matches('[data-studio-option]'))this.choose(event.target);},{signal:this.events.signal});
      this.addEventListener('submit',event=>{if(event.target.matches('.studio-form')){event.preventDefault();this.add(event.target);}},{signal:this.events.signal});
    }
    disconnectedCallback(){this.events?.abort();this.variantRequest?.abort();}
    showError(message){const error=this.querySelector('.studio-error');error.textContent=message||error.dataset.fallback;error.hidden=false;}
    async choose(control){
      this.variantRequest?.abort();this.variantRequest=new AbortController();
      const position=control.dataset.studioOption;
      const target=new URL(control.selectedOptions[0].dataset.url||this.dataset.productUrl,location.origin);
      const browserURL=new URL(location.href);
      for(const key of ['view','preview_theme_id'])if(browserURL.searchParams.has(key))target.searchParams.set(key,browserURL.searchParams.get(key));
      const optionIds=[...this.querySelectorAll('[data-studio-option]')].map(input=>input.value);
      target.searchParams.set('option_values',optionIds.join(','));target.searchParams.set('section_id',this.dataset.section);
      this.querySelectorAll('.studio-add').forEach(button=>button.disabled=true);this.setAttribute('aria-busy','true');this.querySelector('.studio-error').hidden=true;
      try{
        const response=await fetch(target,{signal:this.variantRequest.signal});if(!response.ok)throw new Error();
        const documentFragment=new DOMParser().parseFromString(await response.text(),'text/html');
        const fresh=documentFragment.querySelector('hd-general-product');if(!fresh)throw new Error();
        const oldQuantity=Number(this.querySelector('[name=quantity]').value);const quantity=fresh.querySelector('[name=quantity]');
        const minimum=Number(quantity.min)||1;const increment=Number(quantity.step)||1;const maximum=Number(quantity.max)||Infinity;
        quantity.value=Math.min(maximum,minimum+Math.max(0,Math.floor((oldQuantity-minimum)/increment))*increment);
        const property=this.querySelector('[name="properties[Wunschtext]"]');const nextProperty=fresh.querySelector('[name="properties[Wunschtext]"]');if(property&&nextProperty)nextProperty.value=property.value;
        this.replaceWith(fresh);fresh.querySelector('[data-studio-option="'+position+'"]')?.focus({preventScroll:true});
        browserURL.pathname=target.pathname;browserURL.searchParams.delete('option_values');
        if(fresh.dataset.variant)browserURL.searchParams.set('variant',fresh.dataset.variant);else{browserURL.searchParams.delete('variant');browserURL.searchParams.set('option_values',optionIds.join(','));}
        history.replaceState({},'',browserURL);
      }catch(error){if(error.name!=='AbortError'){this.removeAttribute('aria-busy');this.showError();}}
    }
    async add(form){
      if(this.submitting)return;this.submitting=true;
      const buttons=[...this.querySelectorAll('.studio-add')];buttons.forEach(button=>button.disabled=true);
      this.querySelector('.studio-error').hidden=true;this.querySelector('.studio-success').hidden=true;
      this.querySelectorAll('[data-studio-option]').forEach(input=>input.disabled=true);
      try{
        const response=await fetch(this.dataset.add+'.js',{method:'POST',headers:{Accept:'application/json'},body:new FormData(form)});
        const result=await response.json();if(!response.ok)throw new Error(typeof result.description==='string'?result.description:'');
        this.querySelector('.studio-success').hidden=false;
        const cartResponse=await fetch(this.dataset.cart+'.js',{headers:{Accept:'application/json'}});
        if(cartResponse.ok){const cart=await cartResponse.json();document.querySelectorAll('[data-studio-cart-count]').forEach(count=>count.textContent=cart.item_count);}
      }catch(error){this.showError(error.message);}finally{this.submitting=false;buttons.forEach(button=>button.disabled=false);this.querySelectorAll('[data-studio-option]').forEach(input=>input.disabled=false);}
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hd-print-product"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('hd-print-product')){
  customElements.define('hd-print-product',class extends HTMLElement{
    connectedCallback(){
      this.events=new AbortController();
      this.addEventListener('click',event=>{
        if(event.target.closest('[data-size-open]')){this.querySelector('.studio-size-dialog')?.showModal();return;}
        if(event.target.closest('[data-size-close]')){this.querySelector('.studio-size-dialog')?.close();return;}
        const thumbnail=event.target.closest('[data-photo]');
        if(!thumbnail)return;
        const hero=this.querySelector('.studio-primary');
        if(!hero)return;
        const photo=hero.querySelector('img');
        photo.removeAttribute('srcset');photo.src=thumbnail.dataset.photo;photo.alt=thumbnail.dataset.alt;hero.href=thumbnail.dataset.large;
        this.querySelectorAll('[data-photo]').forEach(button=>button.setAttribute('aria-pressed',String(button===thumbnail)));
        this.querySelector('.studio-pictures').scrollTo({left:0,behavior:'instant'});
      },{signal:this.events.signal});
      this.addEventListener('change',event=>{if(event.target.matches('[data-studio-option]'))this.choose(event.target);},{signal:this.events.signal});

    }
    disconnectedCallback(){this.events?.abort();this.variantRequest?.abort();}
    showError(message){const error=this.querySelector('.studio-error');error.textContent=message||error.dataset.fallback;error.hidden=false;}
    async choose(control){
      this.variantRequest?.abort();this.variantRequest=new AbortController();
      const position=control.dataset.studioOption;
      const target=new URL(control.selectedOptions[0].dataset.url||this.dataset.productUrl,location.origin);
      const browserURL=new URL(location.href);
      for(const key of ['view','preview_theme_id'])if(browserURL.searchParams.has(key))target.searchParams.set(key,browserURL.searchParams.get(key));
      const optionIds=[...this.querySelectorAll('[data-studio-option]')].map(input=>input.value);
      target.searchParams.set('option_values',optionIds.join(','));target.searchParams.set('section_id',this.dataset.section);
      this.querySelectorAll('.studio-add').forEach(button=>button.disabled=true);this.setAttribute('aria-busy','true');this.querySelector('.studio-error').hidden=true;
      try{
        const response=await fetch(target,{signal:this.variantRequest.signal});if(!response.ok)throw new Error();
        const documentFragment=new DOMParser().parseFromString(await response.text(),'text/html');
        const fresh=documentFragment.querySelector('hd-print-product');if(!fresh)throw new Error();
        const oldQuantity=Number(this.querySelector('[name=quantity]').value);const quantity=fresh.querySelector('[name=quantity]');
        const minimum=Number(quantity.min)||1;const increment=Number(quantity.step)||1;const maximum=Number(quantity.max)||Infinity;
        quantity.value=Math.min(maximum,minimum+Math.max(0,Math.floor((oldQuantity-minimum)/increment))*increment);
        const property=this.querySelector('[name="properties[Wunschtext]"]');const nextProperty=fresh.querySelector('[name="properties[Wunschtext]"]');if(property&&nextProperty)nextProperty.value=property.value;
        const form=this.querySelector('.studio-form');
        for(const selector of ['.studio-selectors','.studio-price','[data-print-stock]','.studio-primary','.studio-thumbnails']){
          const current=this.querySelector(selector);const next=fresh.querySelector(selector);if(current&&next)current.replaceWith(next);
        }
        const variantInput=form.querySelector('[name="id"]');variantInput.value=fresh.dataset.variant||'';variantInput.dispatchEvent(new Event('change',{bubbles:true}));
        const currentQuantity=form.querySelector('[name="quantity"]');for(const attr of ['min','max','step']){if(quantity.hasAttribute(attr))currentQuantity.setAttribute(attr,quantity.getAttribute(attr));else currentQuantity.removeAttribute(attr);}currentQuantity.value=quantity.value;
        this.querySelectorAll('.studio-add').forEach((button,index)=>{const next=fresh.querySelectorAll('.studio-add')[index];if(next){button.innerHTML=next.innerHTML;button.disabled=next.disabled;}});
        const mobilePrice=this.querySelector('.studio-mobile-buy strong');if(mobilePrice)mobilePrice.textContent=fresh.querySelector('.studio-mobile-buy strong').textContent;
        this.dataset.variant=fresh.dataset.variant;this.removeAttribute('aria-busy');this.querySelector('[data-studio-option="'+position+'"]')?.focus({preventScroll:true});
        browserURL.pathname=target.pathname;browserURL.searchParams.delete('option_values');
        if(fresh.dataset.variant)browserURL.searchParams.set('variant',fresh.dataset.variant);else{browserURL.searchParams.delete('variant');browserURL.searchParams.set('option_values',optionIds.join(','));}
        history.replaceState({},'',browserURL);
      }catch(error){if(error.name!=='AbortError'){this.removeAttribute('aria-busy');this.showError();}}
    }

  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hd-product"] && !Shopify.designMode) return;
  try {
    
  if(!customElements.get('hd-product'))customElements.define('hd-product',class extends HTMLElement{
    connectedCallback(){
      this.abort=new AbortController();
      this.addEventListener('click',event=>{
        const button=event.target.closest('[data-image]');if(!button)return;
        const image=this.querySelector('.hdp__hero img');if(!image)return;
        image.srcset='';image.src=button.dataset.image;image.alt=button.dataset.alt;
        this.querySelector('.hdp__hero').href=button.dataset.full;
        this.querySelectorAll('[data-image]').forEach(item=>item.setAttribute('aria-pressed',String(item===button)));
      },{signal:this.abort.signal});
      this.addEventListener('change',event=>{if(event.target.matches('[data-option]'))this.changeVariant(event.target);},{signal:this.abort.signal});
    }
    disconnectedCallback(){this.abort?.abort();this.request?.abort();}
    async changeVariant(select){
      this.request?.abort();this.request=new AbortController();
      const position=select.dataset.option;
      const options=Array.from(this.querySelectorAll('[data-option]:checked')).map(item=>item.value);
      const url=new URL(select.dataset.url||this.dataset.url,location.origin);
      const current=new URL(location.href);
      ['view','preview_theme_id'].forEach(key=>{if(current.searchParams.has(key))url.searchParams.set(key,current.searchParams.get(key));});
      url.searchParams.set('option_values',options.join(','));url.searchParams.set('section_id',this.dataset.section);
      this.querySelectorAll('[type=submit]').forEach(button=>button.disabled=true);
      this.setAttribute('aria-busy','true');this.querySelector('.hdp__error').hidden=true;
      try{
        const response=await fetch(url,{signal:this.request.signal});if(!response.ok)throw new Error();
        const doc=new DOMParser().parseFromString(await response.text(),'text/html');const next=doc.querySelector('hd-product');if(!next)throw new Error();
        const quantity=this.querySelector('[name=quantity]').value;
        const text=this.querySelector('[name="properties[Wunschtext]"]')?.value;
        next.querySelector('[name=quantity]').value=quantity;
        if(text!==undefined&&next.querySelector('[name="properties[Wunschtext]"]'))next.querySelector('[name="properties[Wunschtext]"]').value=text;
        this.replaceWith(next);
        next.querySelector('[data-option="'+position+'"]:checked')?.focus({preventScroll:true});
        current.searchParams.delete('option_values');
        if(next.dataset.variant)current.searchParams.set('variant',next.dataset.variant);else{current.searchParams.delete('variant');current.searchParams.set('option_values',options.join(','));}
        current.pathname=url.pathname;history.replaceState({},'',current);
      }catch(error){if(error.name==='AbortError')return;this.removeAttribute('aria-busy');this.querySelector('.hdp__error').hidden=false;}
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hd-sherpa-product"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('hd-sherpa-buy')) {
  customElements.define('hd-sherpa-buy', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      const variants = JSON.parse(this.querySelector('[data-variants]').textContent);
      const labels = JSON.parse(this.querySelector('[data-labels]').textContent);
      const select = this.querySelector('select[name="id"]');
      const button = this.querySelector('[data-buy]');
      const status = this.querySelector('[data-status]');
      const radios = [...this.querySelectorAll('[data-option]')];
      const image = this.closest('.s-buy').querySelector('.s-buy-photo img');
      const original = image ? { src: image.src, srcset: image.srcset, alt: image.alt } : null;
      this.querySelector('[data-options]').hidden = false;
      this.querySelector('[data-fallback]').hidden = true;
      const update = () => {
        const options = [...this.querySelectorAll('[data-option]:checked')].map(input => input.value);
        const variant = variants.find(item => item.options.every((value, index) => value === options[index]));
        select.value = variant ? String(variant.id) : '';
        button.disabled = !variant?.available;
        button.textContent = variant?.available ? labels.button + ' →' : variant ? labels.soldOut : labels.unavailable;
        status.textContent = variant?.available ? '' : variant ? labels.soldOut : labels.unavailable;
        if (variant) this.querySelector('[data-price]').textContent = variant.price;
        if (image && variant?.image) {image.src = variant.image; image.removeAttribute('srcset'); image.alt = variant.options.join(' / ');}
        else if (image && original) {image.src=original.src;image.srcset=original.srcset;image.alt=original.alt;}
        radios.forEach(input => {
          const index = Number(input.dataset.option);
          const possible = variants.some(item => item.available && item.options[index] === input.value && item.options.every((value, i) => i === index || i > index || value === options[i]));
          input.parentElement.classList.toggle('s-unavailable', !possible);
        });
      };
      this.addEventListener('change', update);
      this.querySelector('form').addEventListener('submit', event => { if (button.disabled || !select.value) event.preventDefault(); });
      update();
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hd-studio-product"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('hd-studio-product')){
  customElements.define('hd-studio-product',class extends HTMLElement{
    connectedCallback(){
      this.events=new AbortController();
      this.addEventListener('click',event=>{
        if(event.target.closest('[data-size-open]')){this.querySelector('.studio-size-dialog')?.showModal();return;}
        if(event.target.closest('[data-size-close]')){this.querySelector('.studio-size-dialog')?.close();return;}
        const thumbnail=event.target.closest('[data-photo]');
        if(!thumbnail)return;
        const hero=this.querySelector('.studio-primary');
        if(!hero)return;
        const photo=hero.querySelector('img');
        photo.removeAttribute('srcset');photo.src=thumbnail.dataset.photo;photo.alt=thumbnail.dataset.alt;hero.href=thumbnail.dataset.large;
        this.querySelectorAll('[data-photo]').forEach(button=>button.setAttribute('aria-pressed',String(button===thumbnail)));
        this.querySelector('.studio-pictures').scrollTo({left:0,behavior:'instant'});
      },{signal:this.events.signal});
      this.addEventListener('change',event=>{if(event.target.matches('[data-studio-option]'))this.choose(event.target);},{signal:this.events.signal});
      this.addEventListener('submit',event=>{if(event.target.matches('.studio-form')){event.preventDefault();this.add(event.target);}},{signal:this.events.signal});
    }
    disconnectedCallback(){this.events?.abort();this.variantRequest?.abort();}
    showError(message){const error=this.querySelector('.studio-error');error.textContent=message||error.dataset.fallback;error.hidden=false;}
    async choose(control){
      this.variantRequest?.abort();this.variantRequest=new AbortController();
      const position=control.dataset.studioOption;
      const target=new URL(control.selectedOptions[0].dataset.url||this.dataset.productUrl,location.origin);
      const browserURL=new URL(location.href);
      for(const key of ['view','preview_theme_id'])if(browserURL.searchParams.has(key))target.searchParams.set(key,browserURL.searchParams.get(key));
      const optionIds=[...this.querySelectorAll('[data-studio-option]')].map(input=>input.value);
      target.searchParams.set('option_values',optionIds.join(','));target.searchParams.set('section_id',this.dataset.section);
      this.querySelectorAll('.studio-add').forEach(button=>button.disabled=true);this.setAttribute('aria-busy','true');this.querySelector('.studio-error').hidden=true;
      try{
        const response=await fetch(target,{signal:this.variantRequest.signal});if(!response.ok)throw new Error();
        const documentFragment=new DOMParser().parseFromString(await response.text(),'text/html');
        const fresh=documentFragment.querySelector('hd-studio-product');if(!fresh)throw new Error();
        const oldQuantity=Number(this.querySelector('[name=quantity]').value);const quantity=fresh.querySelector('[name=quantity]');
        const minimum=Number(quantity.min)||1;const increment=Number(quantity.step)||1;const maximum=Number(quantity.max)||Infinity;
        quantity.value=Math.min(maximum,minimum+Math.max(0,Math.floor((oldQuantity-minimum)/increment))*increment);
        const property=this.querySelector('[name="properties[Wunschtext]"]');const nextProperty=fresh.querySelector('[name="properties[Wunschtext]"]');if(property&&nextProperty)nextProperty.value=property.value;
        this.replaceWith(fresh);fresh.querySelector('[data-studio-option="'+position+'"]')?.focus({preventScroll:true});
        browserURL.pathname=target.pathname;browserURL.searchParams.delete('option_values');
        if(fresh.dataset.variant)browserURL.searchParams.set('variant',fresh.dataset.variant);else{browserURL.searchParams.delete('variant');browserURL.searchParams.set('option_values',optionIds.join(','));}
        history.replaceState({},'',browserURL);
      }catch(error){if(error.name!=='AbortError'){this.removeAttribute('aria-busy');this.showError();}}
    }
    async add(form){
      if(this.submitting)return;this.submitting=true;
      const buttons=[...this.querySelectorAll('.studio-add')];buttons.forEach(button=>button.disabled=true);
      this.querySelector('.studio-error').hidden=true;this.querySelector('.studio-success').hidden=true;
      this.querySelectorAll('[data-studio-option]').forEach(input=>input.disabled=true);
      try{
        const response=await fetch(this.dataset.add+'.js',{method:'POST',headers:{Accept:'application/json'},body:new FormData(form)});
        const result=await response.json();if(!response.ok)throw new Error(typeof result.description==='string'?result.description:'');
        this.querySelector('.studio-success').hidden=false;
        const cartResponse=await fetch(this.dataset.cart+'.js',{headers:{Accept:'application/json'}});
        if(cartResponse.ok){const cart=await cartResponse.json();document.querySelectorAll('[data-studio-cart-count]').forEach(count=>count.textContent=cart.item_count);}
      }catch(error){this.showError(error.message);}finally{this.submitting=false;buttons.forEach(button=>button.disabled=false);this.querySelectorAll('[data-studio-option]').forEach(input=>input.disabled=false);}
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
